import createCache from "@emotion/cache";

// Copied from https://github.com/mui-org/material-ui/blob/abac3886a60c4f732023826695d3ea92a0bc2e81/examples/nextjs-with-typescript/src/createEmotionCache.ts
// under the MIT license
// prepend: true moves MUI styles to the top of the <head> so they're loaded first.
// It allows developers to easily override MUI styles with other styling solutions, like CSS modules.
export default function createEmotionCache() {
	return createCache({ key: "css", prepend: true });
}
